export { useSlider, useZoom } from './hooks';
export { default } from './Slider';
